export enum EPlacingType {
  package = 'package',
  balance = 'balance',
}
